import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
var state = {
    jobLists: [],
    loading: false,
    jobListCreateApiError: false,
    jobListUpdateApiError: false,
    jobListSharingSettings: null,
};
export var jobLists = {
    state: state,
    namespaced: true,
    actions: actions,
    mutations: mutations,
    getters: getters,
};
